/* Source: /app/components/ErrorAlert.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Alert, Group, Text, Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
function ErrorAlert(props) {
  const {error: error = null, onClose: onClose = null, onRetry: onRetry = null} = props;
  if (!error) {
    return __jacJsx(null, {}, []);
  }
  let code = (error.code || "ERR_UNKNOWN_FRONTEND");
  let message = (error.message || "Something went wrong. Please try again.");
  let retryable = (error.retryable || false);
  return __jacJsx(Alert, {"icon": __jacJsx(IconAlertCircle, {"size": 16}, []), "color": "red", "variant": "light", "withCloseButton": true, "onClose": onClose, "styles": {"root": {"background": "rgba(239, 68, 68, 0.08)", "border": "1px solid rgba(239, 68, 68, 0.25)"}, "message": {"color": "#fecaca"}}}, [__jacJsx(Group, {"justify": "space-between", "align": "center", "wrap": "nowrap"}, [__jacJsx(Text, {"size": "sm"}, [((("[" + code) + "] ") + message)]), ((retryable && onRetry) ? __jacJsx(Button, {"size": "xs", "variant": "outline", "color": "red", "onClick": onRetry}, ["Retry"]) : null)])]);
}
/*jac:refresh-boundary*/;
export {ErrorAlert};
//# sourceMappingURL=ErrorAlert.js.map
